const PRIORITY_DEFAULTS = Object.freeze({
  LOW: { showBell: true, showToast: false, playSound: false, showBrowserNotification: false, toastDurationMs: 4000, toastSticky: false },
  NORMAL: { showBell: true, showToast: true, playSound: false, showBrowserNotification: false, toastDurationMs: 5000, toastSticky: false },
  HIGH: { showBell: true, showToast: true, playSound: false, showBrowserNotification: false, toastDurationMs: 8000, toastSticky: false },
  CRITICAL: { showBell: true, showToast: true, playSound: true, showBrowserNotification: true, toastDurationMs: Infinity, toastSticky: true },
});

function normalizePriority(priority) {
  const normalized = String(priority || 'NORMAL').toUpperCase();
  return PRIORITY_DEFAULTS[normalized] ? normalized : 'NORMAL';
}

export function resolveNotificationPresentation(notification = {}, preferences = {}) {
  const priority = normalizePriority(notification.priority);
  const capability = notification.presentation || notification.capability?.presentation || {};
  const policy = { ...PRIORITY_DEFAULTS[priority], ...capability };
  if (preferences.toastsEnabled === false) policy.showToast = false;
  if (preferences.soundsEnabled === false || preferences.muted === true || preferences.quietHoursActive === true) policy.playSound = false;
  if (preferences.browserNotificationsEnabled === false || preferences.quietHoursActive === true) policy.showBrowserNotification = false;
  return { ...policy, priority };
}

export { PRIORITY_DEFAULTS };
